import CryptoJS from 'crypto-js';

export function setPhoneNumber(number) {
  return localStorage.setItem('userPhoneNumber', number);
}

export function getPhoneNumber() {
  return localStorage.getItem('userPhoneNumber');
}

export function hashPassword(password) {
  const hash = CryptoJS.SHA256(password);
  return hash.toString(CryptoJS.enc.Base64);
}

export function setAuthToken(token) {
  return localStorage.setItem('access_token', token);
}

export function getAuthToken() {
  return localStorage.getItem('access_token');
}

export function removeAuthToken() {
  return localStorage.removeItem('access_token');
}

export function isAuthenticated() {
  return !!localStorage.getItem('access_token');
  //todo check also expiration
}

export function setUserId(id) {
  return localStorage.setItem('user_id', id);
}

export function getUserId() {
  return localStorage.getItem('user_id');
}

export function removeUserId() {
  return localStorage.removeItem('user_id');
}



/** WEBPACK FOOTER **
 ** ./src/logic/authHelpers.js
 **/